import { BeneficiariesModel } from './../../domain/transfer/transfer.model';
import { Observable } from 'rxjs';

export abstract class PurposesRepository {
  abstract getAllPurposes(): Observable<BeneficiariesModel>;
}
